<template>
  <div class="avatar-container">
    <div class="avatar-wrapper">
      <div class="avatar-image" :style="backgroundImage"></div>

      <div class="avatar-text-wrapper">
        <div class="avatar-text">
          <div class="username">{{stylistUsername}}</div>
          <div class="date">{{formattedPublishedOnDate}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stylistUsername: {
      type: String,
      required: true
    },
    stylistAvatarUrl: {
      type: String,
      required: true
    },
    publishedDate: {
      type: String,
      default: "",
      required: false
    }
  },

  computed: {
    backgroundImage() {
      if (this.stylistAvatarUrl !== null) {
        return `background-image: url("${this.stylistAvatarUrl}")`;
      }
    },

    formattedPublishedOnDate() {
      /*
        TODO: Displaying time
          - If less than 7 days show "6 days ago", etc, else show date as below
          - Make this time relative to a users current timezone
      */
      return this.$moment(this.publishedDate).fromNow();
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

@media only screen and (min-device-width: 768px) {
}

@media only screen and (min-width: 1224px) {
}

.avatar-container {
  flex: 0 0 auto;
  width: 100%;

  @media only screen and (min-device-width: 768px) {
    width: 190px;
  }
}

.avatar-wrapper {
  display: flex;
  width: 100%;
}

.avatar-text-wrapper {
  display: flex;
  flex-direction: column;

  @media only screen and (min-device-width: 768px) {
    display: flex;
    align-items: center;
  }
}

.avatar-text {
  font-size: 12px;
  text-transform: none;

  .username {
    font-weight: 500;
  }

  .date {
    padding-top: 5px;
  }
}

.avatar-image {
  height: 49px;
  width: 48px;
  margin-right: 10px;
  background-color: #030c22;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media only screen and (min-device-width: 768px) {
    height: 62px;
    width: 62px;
    border: 1px solid #030c22;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/showCapsule/Avatar.vue